<template>
  <transition name="fade">
    <div class="page-alert warning">
      <i class="page-alert__icon far fa-exclamation-circle"></i>
      <div>
        <div class="page-alert__title"></div>
        <div class="page-alert__body" v-html="__('info:reauthenticating')"></div>
      </div>
    </div>
  </transition>
</template>


<script>
import { sleep } from 'common/helpers/async-tools'
export default {
  computed: {
  },
  created() {
  },
  mounted: async function () {
    await sleep(1000)
    await this.$store.dispatch('global/reauthenticateUser')
  }
};
</script>
